import type { OrderStatus } from '@epasu/core';
import { ORDER_STATUS_LABELS } from '@epasu/core/constants';

/**
 * Status eines Auftrags als farbige Pille.
 *
 * Von der Projekt-Pille getrennt: gemeinsame Farben für zwei verschiedene
 * Statuslisten hätten bedeutet, dass „abgeschlossen“ und „abgerechnet“ gleich
 * aussehen. Stand früher in `OrdersPage`; die Seite gibt es nicht mehr.
 */
const STATUS_FARBEN: Record<OrderStatus, string> = {
  offen: 'bg-slate-100 text-slate-700',
  in_arbeit: 'bg-blue-100 text-blue-800',
  geliefert: 'bg-emerald-100 text-emerald-800',
  abgerechnet: 'bg-violet-100 text-violet-800',
  storniert: 'bg-rose-100 text-rose-800',
};

export function OrderStatusPill({ status }: { status: OrderStatus }) {
  return (
    <span
      className={`rounded px-2 py-0.5 text-xs font-medium ${
        STATUS_FARBEN[status] ?? 'bg-muted text-muted-foreground'
      }`}
    >
      {ORDER_STATUS_LABELS[status] ?? status}
    </span>
  );
}
